import { render, staticRenderFns } from "./topvue.vue?vue&type=template&id=3048f50c&"
import script from "./topvue.vue?vue&type=script&lang=js&"
export * from "./topvue.vue?vue&type=script&lang=js&"
import style0 from "./topvue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports